// POST /auth/telegram · POST /auth/refresh
import { z } from 'zod'
import { userDtoSchema } from './user.js'

// Обычный вход — initData от Telegram WebApp. В dev-режиме (AUTH_DEV_BYPASS=true, не в проде)
// бэкенд также принимает { dev_user_id } без подписи — см. backend.md §4.
export const authTelegramRequestSchema = z.union([
  z.object({ init_data: z.string().min(1) }),
  z.object({ dev_user_id: z.string().min(1) }),
])
export type AuthTelegramRequest = z.infer<typeof authTelegramRequestSchema>

export const authTelegramResponseSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
  user: userDtoSchema,
  is_new: z.boolean(),
})
export type AuthTelegramResponse = z.infer<typeof authTelegramResponseSchema>

// POST /auth/refresh
export const authRefreshRequestSchema = z.object({
  refresh_token: z.string().min(1),
})
export type AuthRefreshRequest = z.infer<typeof authRefreshRequestSchema>

export const authRefreshResponseSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
})
export type AuthRefreshResponse = z.infer<typeof authRefreshResponseSchema>
